module.exports = __webpack_public_path__ + "static/media/SourceSans3VF-Roman.16a3ecbb.otf";